import { cutBreadcrumbActiveItem } from './cut-breadcrumb'

const resizeObserver = new ResizeObserver((entries) => {
  cutBreadcrumbActiveItem();
});



document.addEventListener("DOMContentLoaded", function(event) {
  resizeObserver.observe(document.querySelector(('body')))
  let copyButton = document.querySelector('#copy-button');
  if(copyButton){

    copyButton.addEventListener('click',()=>{
      if(window.isSecureContext) {
        navigator.clipboard.writeText(window.location.href);
      }

      let copyButtonOriginalText = copyButton.innerHTML;
      copyButton.innerHTML = 'Skopiowano ! '

      setTimeout(()=>{
        copyButton.innerHTML = copyButtonOriginalText;
      },1500)


    })

  }
});


/**
 * Remove newsletter from DOM to prevent doubled id attributes
 */
const removeNewsletter = () => {

  if ( window.innerWidth < 768 ) {
    var newsletterWrapper = document.querySelector( '.panel.newsletter' );
  } else {
    var newsletterWrapper = document.querySelector( '.newsletter-group' );
  }

  if ( ! newsletterWrapper ) {
    return;
  }

  const form = newsletterWrapper.querySelector( '.gravity-newsletter_wrapper' );
  const iframe = newsletterWrapper.querySelector( 'iframe' );
  const script = newsletterWrapper.querySelector( 'script' );

  form && form.remove();
  iframe && iframe.remove();
  script && script.remove();

}


window.addEventListener( 'DOMContentLoaded', () => {
  removeNewsletter();
})